import { render, staticRenderFns } from "./TagCategoryForm.vue?vue&type=template&id=734aa1da&scoped=true&"
import script from "./TagCategoryForm.vue?vue&type=script&lang=js&"
export * from "./TagCategoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734aa1da",
  null
  
)

export default component.exports